import React from 'react';

type Props = {
  data: any;
  index: number;
  isMobileOrTablet: boolean;
  onShowDriverDetails: (driver: any, busVehicle?: any) => void;
};

const Driver = ({
  data,
  index,
  isMobileOrTablet,
  onShowDriverDetails
}: Props) => {
  return (
    <div className="flex justify-between text-center text-sm items-start">
      {isMobileOrTablet && <p className="text-gray-600 font-medium">Chofer</p>}

    {(data[index].preAssignedDriver ||  (data[index].serviceType === 'Buses' &&
          data[index].bus_requirement?.vehicle?.patent)) && <div className="flex flex-col cursor-pointer rounded-md bg-gray-50 p-2 dark:bg-gray-900/40 w-fit text-blue-600 dark:text-blue-400">
        <p
          className="text-sm font-medium "
          onClick={() => onShowDriverDetails(
              data[index].preAssignedDriver!,
              data[index].serviceType === 'Buses'
                ? data[index].bus_requirement?.vehicle
                : undefined
            )}
        >
          {data[index].preAssignedDriver?.codigo}
        </p>

        <p className="text-xs text-center w-28">
          {data[index].preAssignedDriver?.nombreCompleto}
        </p>

        {data[index].serviceType === 'Buses' &&
          data[index].bus_requirement?.vehicle?.patent && (
            <p className="text-[16px] text-center bg-blue-100 text-blue-800 px-4 py-0.5 rounded-md w-fit font-semibold mt-2 shadow-sm">
              {data[index].bus_requirement.vehicle.patent}
            </p>
          )}
      </div>}
    </div>
  );
};

export default Driver;
